import { connect } from "react-redux";
import { GlobalActions } from "../components/GlobalActions";
import { doCursedApplyFilters, doCursedExecuteGlobalAction, doCursedResetFilters } from "../actions/thunks";
import { changeColumnVisibility, closeFilters, openFilters, setFilterFormError } from "../../kptable/actions/actions";
import { askConfirmation } from "../../kptable/utils";
function mapStateToProps({ kpcursedtable }, { id }) {
    return {
        columnVisibility: kpcursedtable[id].columnVisibility,
        hasChecked: Object.keys(kpcursedtable[id].checked).some((key) => kpcursedtable[id].checked[key]),
        checked: kpcursedtable[id].checked,
        dirtyFilters: kpcursedtable[id].dirtyFilters,
        filtersOpened: kpcursedtable[id].filtersOpened,
        filter: kpcursedtable[id].filter,
        filterFormError: kpcursedtable[id].filterFormError,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onChangeColumnVisibility: (id, key, visibility) => dispatch(changeColumnVisibility(id, key, visibility)),
        onHandleGlobalAction: async (id, action, data, keyField) => {
            if (!action.confirmation || (await askConfirmation(action.confirmation))) {
                await dispatch(doCursedExecuteGlobalAction(id, action, data, keyField));
            }
        },
        onOpenFilters: (id) => dispatch(openFilters(id)),
        onCloseFilters: (id) => dispatch(closeFilters(id)),
        onResetFilters: (id, loaderFunc) => dispatch(doCursedResetFilters(id, loaderFunc)),
        onApplyFilters: (id, loaderFunc) => dispatch(doCursedApplyFilters(id, loaderFunc)),
        onSetFilterFormError: (id, hasError) => dispatch(setFilterFormError(id, hasError)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(GlobalActions);
